import React, { useEffect, useState } from 'react';
import { getHighlight } from '../../../../apis/Ambition';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';
import { useRef } from 'react';

export const OurGoals = () => {
  const [employeeCommitment, setEmployeeCommitment] = useState("");
  const [employeeKpi, setEmployeeKPI] = useState("");
  const [employeeStarting, setEmployeeStarting] = useState("");
  const [employeeNext, setEmployeeNext] = useState("");
  const [employeeTarget, setEmployeeTarget] = useState("");

  const [companyCommitment, setCompanyCommitment] = useState("");
  const [companyKpi, setCompanyKPI] = useState("");
  const [companyStarting, setCompanyStarting] = useState("");
  const [companyNext, setCompanyNext] = useState("");
  const [companyTarget, setCompanyTarget] = useState("");

  const [productCommitment, setProductCommitment] = useState("");
  const [productKpi, setProductKPI] = useState("");
  const [productStarting, setProductStarting] = useState("");
  const [productNext, setProductNext] = useState("");
  const [productTarget, setProductTarget] = useState("");

  const [userCommitment, setUserCommitment] = useState("");
  const [userKpi, setUserKPI] = useState("");
  const [userStarting, setUserStarting] = useState("");
  const [userNext, setUserNext] = useState("");
  const [userTarget, setUserTarget] = useState("");

  const [societyCommitment, setSocietyCommitment] = useState("");
  const [societyKpi, setSocietyKPI] = useState("");
  const [societyStarting, setSocietyStarting] = useState("");
  const [societyNext, setSocietyNext] = useState("");
  const [societyTarget, setSocietyTarget] = useState("");

  const [beyondCommitment, setBeyondCommitment] = useState("");
  const [beyondKpi, setBeyondKPI] = useState("");
  const [beyondStarting, setBeyondStarting] = useState("");
  const [beyondNext, setBeyondNext] = useState("");
  const [beyondTarget, setBeyondTarget] = useState("");

  useEffect(() => {
    getHighlight({ key: "employees_commitment", setValue: setEmployeeCommitment });
    getHighlight({ key: "employees_kpi", setValue: setEmployeeKPI });
    getHighlight({ key: "employees_starting", setValue: setEmployeeStarting });
    getHighlight({ key: "employees_nextyear", setValue: setEmployeeNext });
    getHighlight({ key: "employees_target", setValue: setEmployeeTarget });

    getHighlight({ key: "company_commitment", setValue: setCompanyCommitment });
    getHighlight({ key: "company_kpi", setValue: setCompanyKPI });
    getHighlight({ key: "company_starting", setValue: setCompanyStarting });
    getHighlight({ key: "company_nextyear", setValue: setCompanyNext });
    getHighlight({ key: "company_target", setValue: setCompanyTarget });

    getHighlight({ key: "products_commitment", setValue: setProductCommitment });
    getHighlight({ key: "products_kpi", setValue: setProductKPI });
    getHighlight({ key: "products_starting", setValue: setProductStarting });
    getHighlight({ key: "products_nextyear", setValue: setProductNext });
    getHighlight({ key: "products_target", setValue: setProductTarget });

    getHighlight({ key: "users_commitment", setValue: setUserCommitment });
    getHighlight({ key: "users_kpi", setValue: setUserKPI });
    getHighlight({ key: "users_starting", setValue: setUserStarting });
    getHighlight({ key: "users_nextyear", setValue: setUserNext });
    getHighlight({ key: "users_target", setValue: setUserTarget });

    getHighlight({ key: "society_commitment", setValue: setSocietyCommitment });
    getHighlight({ key: "society_kpi", setValue: setSocietyKPI });
    getHighlight({ key: "society_starting", setValue: setSocietyStarting });
    getHighlight({ key: "society_nextyear", setValue: setSocietyNext });
    getHighlight({ key: "society_target", setValue: setSocietyTarget });

    getHighlight({ key: "beyond_commitment", setValue: setBeyondCommitment });
    getHighlight({ key: "beyond_kpi", setValue: setBeyondKPI });
    getHighlight({ key: "beyond_starting", setValue: setBeyondStarting });
    getHighlight({ key: "beyond_nextyear", setValue: setBeyondNext });
    getHighlight({ key: "beyond_target", setValue: setBeyondTarget });
  }, []);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourgoals" ref={ref}>
      <h2 style={{ fontSize: fontReport(width,PRINT_WIDTH,51/PRINT_WIDTH,"px")}}>Our Goals</h2>
      <div className="page__table">
        <div className="writeinbox__table">
          <div className="writeinbox__header">
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Roadmap</h5>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Commitment</h5>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>KPI</h5>
          </div>
          <div className="writeinbox__body">
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Employees</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{employeeCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{employeeKpi}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Company</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{companyCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{companyKpi}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Products</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{productCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{productKpi}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Users</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{userCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{userKpi}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Society</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{societyCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{societyKpi}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Beyond</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{beyondCommitment}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{beyondKpi}</h5>
            </div>
          </div>
        </div>
        <div className="writeinbox__table" style={{marginTop:"4.7%"}}>
          <div className="writeinbox__header">
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Roadmap</h5>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Starting Point</h5>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Next Year Target</h5>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>2030 Target</h5>
          </div>
          <div className="writeinbox__body">
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Employees</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{employeeStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{employeeNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{employeeTarget}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Company</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{companyStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{companyNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{companyTarget}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Products</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{productStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{productNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{productTarget}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Users</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{userStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{userNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{userTarget}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Society</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{societyStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{societyNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{societyTarget}</h5>
            </div>
            <div className="writeinbox__row">
              <p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p><p style={{height: fontReport(width,PRINT_WIDTH,10/PRINT_WIDTH,"px")}}></p>
            </div>
            <div className="writeinbox__row">
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>Beyond</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{beyondStarting}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{beyondNext}</h5>
              <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.12/PRINT_WIDTH,"rem")}}>{beyondTarget}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};
